module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/auth/register/register.component.scss
// module id = ./src/app/routes/auth/register/register.component.scss
// module chunks = main